<template>
  <chart title="Paid Tariffs" @filtersChanged="update" :apiData="filteredAll" :hiddenDatasets="hiddenDatasets" />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Chart from '@/components/Chart'

export default {
  name: 'UsersPaidTariffsAll',
  components: {
    Chart,
  },
  data() {
    return {
      hiddenDatasets: ['free'],
    }
  },
  computed: {
    ...mapState('users/tariffs', ['all']),
    filteredAll() {
      const filtered = { ...this.all }
      Object.keys(filtered).forEach(key => {
        delete filtered[key].nulll
        delete filtered[key].free
      })
      return filtered
    },
  },
  methods: {
    ...mapActions('users/tariffs', ['getAll']),
    update({ startDate, endDate }) {
      this.getAll({ startDate, endDate })
    },
  },
}
</script>
